import { ASSET_PATHS } from '../../utils/assetPath';

import './InfoIcon.css';

interface InfoIconProps {
  /**
   * Additional CSS class names
   */
  className?: string;
  /**
   * Size of the icon in pixels
   */
  size?: number;
  /**
   * Accessible name for the icon. Empty (the default) renders it as decorative:
   * every current usage sits inside a Tooltip trigger or a link that already
   * carries the name, so a name here is appended to theirs as noise.
   */
  ariaLabel?: string;
  /**
   * Use inverted color variant
   */
  inverted?: boolean;
}

/**
 * InfoIcon component
 *
 * Displays an information circle icon using the SVG from the public folder.
 * Used primarily in tooltips throughout the application.
 *
 * @example
 * <InfoIcon />
 * <InfoIcon size={20} ariaLabel="More information" />
 * <InfoIcon inverted />
 */
function InfoIcon({ className = '', size = 18, ariaLabel = '', inverted = false }: InfoIconProps) {
  const iconSrc = inverted ? ASSET_PATHS.INFO_CIRCLE_INVERTED_ICON : ASSET_PATHS.INFO_CIRCLE_ICON;

  return (
    <img
      alt={ariaLabel}
      aria-hidden={ariaLabel ? undefined : 'true'}
      className={`info-icon ${className}`}
      height={size}
      role={ariaLabel ? 'img' : undefined}
      src={iconSrc}
      width={size}
    />
  );
}

export default InfoIcon;
